import { Link } from "react-router-dom";

const quickLinks = [
  { label: "CyberSOC 24/7", href: "/cybersoc", icon: "ri-shield-flash-line" },
  { label: "Service Desk", href: "/service-desk", icon: "ri-headphone-line" },
  { label: "Datacenter", href: "/datacenter", icon: "ri-server-line" },
  { label: "Consultoria", href: "/consultoria", icon: "ri-file-shield-line" },
  { label: "Contáctanos", href: "/contactanos", icon: "ri-mail-send-line" },
];

const socials = [
  { icon: "ri-linkedin-fill", href: "https://linkedin.com/company/openlabsecureperu", label: "LinkedIn" },
  { icon: "ri-facebook-fill", href: "https://facebook.com/openlabsecureperu", label: "Facebook" },
  { icon: "ri-instagram-fill", href: "https://instagram.com/openlabsecure.peru", label: "Instagram" },
  { icon: "ri-youtube-fill", href: "https://youtube.com/openlabsecure.peru", label: "YouTube" },
  { icon: "ri-tiktok-fill", href: "https://www.tiktok.com/@OpenlabSecure.peru", label: "TikTok" },
];

interface LandingFooterProps {
  pageName: string;
}

export default function LandingFooter({ pageName }: LandingFooterProps) {
  return (
    <footer className="relative bg-[#0F1C2E]">
      <div className="h-[2px] bg-gradient-to-r from-transparent via-[#4A7DBF]/50 to-transparent" />

      <div className="w-full px-6 sm:px-8 lg:px-12 py-6 md:py-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-5">
            {/* Logo + Description */}
            <div>
              <Link to="/" className="flex items-center gap-2.5 cursor-pointer group mb-3">
                <img
                  src="https://storage.helloreaddy.io/project_files/b2c15536-355d-426f-a10e-89e210e7256f/284a1860-12a0-47a5-b9c0-f19215b3f5a7_compressed_icono4x.webp"
                  alt="Openlab Secure"
                  className="h-7 w-auto"
                  decoding="async"
                />
                <span className="font-heading font-bold text-sm text-white tracking-wide">
                  Openlab<span className="text-primary-400"> Secure</span>
                </span>
              </Link>
              <p className="text-[12px] text-foreground-300/60 leading-relaxed max-w-xs">
                Consultoría en Ciberseguridad y Datacenter con presencia en América y Europa. 
                Protegemos lo que más valoras con soluciones de clase mundial.
              </p>
              <p className="text-[11px] text-foreground-400/40 mt-2">
                Actualmente en <span className="text-primary-300 font-semibold">{pageName}</span>
              </p>
            </div>

            {/* Enlaces rapidos */}
            <div>
              <h6 className="font-heading font-semibold text-sm text-white mb-3 tracking-wide flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#4A7DBF]" />
                Enlaces Rapidos
              </h6>
              <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                {quickLinks.map((link) => (
                  <Link
                    key={link.label}
                    to={link.href}
                    className="text-[12px] text-foreground-300/70 hover:text-primary-300 transition-colors duration-300 font-body tracking-wide cursor-pointer inline-flex items-center gap-1.5 group py-0.5"
                  >
                    <span className="w-1 h-1 rounded-full bg-primary-400/0 group-hover:bg-primary-400/60 transition-colors flex-shrink-0" />
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Social + Contact */}
            <div>
              <h6 className="font-heading font-semibold text-sm text-white mb-3 tracking-wide flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-400" />
                Siguenos
              </h6>
              <div className="flex flex-wrap items-center gap-2 mb-4">
                {socials.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 border border-white/8 text-foreground-300/50 hover:text-white hover:border-[#4A7DBF]/40 hover:bg-[#4A7DBF]/15 transition-all duration-300 cursor-pointer"
                    aria-label={social.label}
                  >
                    <i className={`${social.icon} text-sm`} />
                  </a>
                ))}
              </div>

              <a
                href="mailto:hola@openlabsecure.com"
                className="inline-flex items-center gap-2 text-[12px] text-foreground-300/70 font-body hover:text-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-[#4A7DBF]/60 text-xs" />
                hola@openlabsecure.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="w-full px-6 sm:px-8 lg:px-12 py-3">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
            <span className="text-[12px] text-foreground-400/50 font-body">
              Openlab Secure &copy; {new Date().getFullYear()} &mdash; Todos los derechos reservados
            </span>
            <p className="text-[11px] text-foreground-400/40">
              Consultoría en Ciberseguridad y Datacenter
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}